import { fexPost } from "@/utils/fex"

export const addToMailingList = async ({sectionId,email}:{sectionId:string,email:string})=>{
    try{
        const res = await fexPost("api/mailing-list/"+sectionId,{email})
    }catch(err){
        console.error(err)
    }
}